import { useMutation } from '@tanstack/react-query';
import { axios } from '@src/lib/axios';

const URL = '/docusign/validate';

const validateGovernmentId = ({ signerEmail, signerName, clientUserId, dsReturnUrl, envelopeId }) => {
    return axios.post(URL, {
        signerEmail,
        signerName,
        clientUserId,
        dsReturnUrl,
        envelopeId
    });
};
export const useValidateGovernmentId = () =>
    useMutation({
        mutationFn: validateGovernmentId
    });
